import { render, staticRenderFns } from "./TitleHeader.vue?vue&type=template&id=080fd448&"
import script from "./TitleHeader.vue?vue&type=script&lang=js&"
export * from "./TitleHeader.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports